module.exports = __webpack_public_path__ + "static/Metomic-0ecbd84f8b7d284594a6ede8524cf857.jpg";